// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RT9Xm","index":"styles_index__1qK-j"};